<div class="overlay">
  <div class="dialog">
    <section class="confirm-delete-container">
      <form (ngSubmit)="onSubmit()" class="form">
        <h2 class="bold-text">
          {{ "forgetPassword.requestAnOTP" | translate }}
        </h2>
        <h3 class="light-text">{{ "forgetPassword.p" | translate }}</h3>

        <app-otp-input
          [textControl]="this.requestOtpForm.controls.otp"
          (otpSend)="this.sendOtp()"
          identifier="forget-password"
        ></app-otp-input>

        <app-dialog-action-buttons
          [config]="{
            cancelButton: true,
            actionButton: true,
            actionButtonConfigs: {
            type: 'button',
            text: 'common.confirm' | translate,
            form: this.requestOtpForm
          },
          }"
        ></app-dialog-action-buttons>
      </form>
    </section>
  </div>
</div>
